var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Jobs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Jobs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "business_center_24dp_5F6368_FILL1_wght400_GRAD0_opsz24",
    transform: "translate(2, 3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,19 C1.45,19 0.979166667,18.8041667 0.5875,18.4125 C0.195833333,18.0208333 0,17.55 0,17 L0,13 L7,13 L7,15 L13,15 L13,13 L20,13 L20,17 C20,17.55 19.8041667,18.0208333 19.4125,18.4125 C19.0208333,18.8041667 18.55,19 18,19 L2,19 Z",
    id: "path_secondary",
    fill: "#98A6D6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#98A6D6",
    points: "9 13 9 11 11 11 11 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C12.55,0 13.0208333,0.195833333 13.4125,0.5875 C13.8041667,0.979166667 14,1.45 14,2 L14,4 L18,4 C18.55,4 19.0208333,4.19583333 19.4125,4.5875 C19.8041667,4.97916667 20,5.45 20,6 L20,11 L13,11 L13,9 L7,9 L7,11 L0,11 L0,6 C0,5.45 0.195833333,4.97916667 0.5875,4.5875 C0.979166667,4.19583333 1.45,4 2,4 L6,4 L6,2 C6,1.45 6.19583333,0.979166667 6.5875,0.5875 C6.97916667,0.195833333 7.45,0 8,0 L12,0 Z M12,2 L8,2 L8,4 L12,4 L12,2 Z",
    id: "path_primary",
    fill: "#4C69BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJobs);
export default __webpack_public_path__ + "static/media/icon-jobs.e738cde2.svg";
export { ForwardRef as ReactComponent };